import { motion } from "framer-motion";
import { springs } from "@/components/ui";
import { ReportGridCard } from "./ReportGridCard";
import type { ReportView } from "./ReportListView";

interface ReportGridViewProps {
  reports: ReportView[];
  onCardClick: (id: string) => void;
  onDownload: (report: ReportView) => void;
}

export function ReportGridView({
  reports,
  onCardClick,
  onDownload,
}: ReportGridViewProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -6 }}
      transition={springs.snappy}
      className="h-full overflow-auto p-1"
    >
      <div className="grid grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-4">
        {reports.map((report, i) => (
          <ReportGridCard
            key={report.id}
            report={report}
            index={i}
            onClick={onCardClick}
            onDownload={onDownload}
          />
        ))}
      </div>
    </motion.div>
  );
}
